import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, TransitionGroup as _TransitionGroup, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2 mb-4 font-medium"
}
const _hoisted_2 = { class: "flex flex-wrap items-center mb-6 mr-2" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"15px !important","margin-left":"0.5px !important"},
  class: "material-icons"
}, "close", -1)
const _hoisted_6 = { class: "text-muted text-sm mt-0.5" }
const _hoisted_7 = { class: "relative mt-8" }
const _hoisted_8 = {
  key: 0,
  class: "absolute top-0 transform -translate-x-1/2 left-1/2"
}
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "flex items-center mr-8 space-x-4" }
const _hoisted_11 = {
  key: 1,
  class: "flex flex-col items-center mx-2 mt-12"
}
const _hoisted_12 = { class: "font-medium" }
const _hoisted_13 = { class: "text-muted" }
const _hoisted_14 = ["onClick", "onKeyup"]
const _hoisted_15 = { class: "flex items-center space-x-4" }
const _hoisted_16 = { class: "flex flex-col" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _directive_wave = _resolveDirective("wave")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (_ctx.addingUsers.length > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.addingUsers.length) + " " + _toDisplayString(_ctx.$tc("misc.selected", _ctx.addingUsers.length)), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_TransitionGroup, { name: "quick-bounce" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addingUsers, (user) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mr-2.5 mb-2.5 bg-light flex px-3 my-auto w-max rounded-full",
              key: user.email
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Avatar, {
                  user: user,
                  class: "-ml-3 mr-1.5"
                }, null, 8, ["user"]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", null, _toDisplayString(user.full_name), 1)
                ]),
                _createVNode(_component_Btn, {
                  variant: 'icon',
                  class: "ml-2 -mr-2 bg-gray-200",
                  outline: true,
                  size: 'xs',
                  onClick: ($event: any) => (_ctx.onRemoveUser(user))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_TextInput, {
      modelValue: _ctx.searchText,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
      class: "mt-4"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("course_insights.search_student")), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("course_permissions.search_user_hint")), 1),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.loadingUsers)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_Spinner, { size: 'lg' })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["w-full transition-all duration-75 ease-in-out", [_ctx.isAtTop ? 'bg-transparent' : 'top-edge-shadow']])
      }, null, 2),
      _createElementVNode("div", {
        class: "mt-4 -mb-3 overflow-auto h-100",
        id: _ctx.scrollableElementId
      }, [
        (_ctx.filteredUsers.length === 0 && _ctx.isSearchTextValidEmail)
          ? _withDirectives((_openBlock(), _createElementBlock("div", {
              key: 0,
              tabindex: "0",
              class: _normalizeClass(["px-2 py-2 transition-colors duration-75 cursor-pointer", [
						_ctx.isUserSelected({ email: _ctx.searchText })
							? 'text-primary-dark bg-primary-light hover:bg-primary-light bg-opacity-15 hover:bg-opacity-20'
							: 'hover:bg-light',
					]]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onToggleUser({ email: _ctx.searchText }))),
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.onToggleUser({ email: _ctx.searchText })), ["enter"]))
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_Avatar, {
                  user: { full_name: _ctx.searchText }
                }, null, 8, ["user"]),
                _createElementVNode("p", null, _toDisplayString(_ctx.searchText), 1)
              ])
            ], 34)), [
              [_directive_wave]
            ])
          : _createCommentVNode("", true),
        (_ctx.filteredUsers.length === 0 && !_ctx.isSearchTextValidEmail && !_ctx.loadingUsers)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t("course_permissions.search_cant_find_user")), 1),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("course_permissions.try_with_email_hint")), 1)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsers, (user) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            tabindex: "0",
            class: _normalizeClass(["px-2 py-2 transition-colors duration-75 cursor-pointer", [
						_ctx.isUserSelected(user)
							? 'text-primary-dark bg-primary-light hover:bg-primary-light bg-opacity-15 hover:bg-opacity-20'
							: 'hover:bg-light',
					]]),
            key: user.id,
            onClick: ($event: any) => (_ctx.onToggleUser(user)),
            onKeyup: _withKeys(($event: any) => (_ctx.onToggleUser(user)), ["enter"])
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_Avatar, { user: user }, null, 8, ["user"]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("p", {
                  innerHTML: _ctx.highlightMatchingText(_ctx.searchText, user.full_name)
                }, null, 8, _hoisted_17),
                (user.email !== user.full_name)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      innerHTML: _ctx.highlightMatchingText(_ctx.searchText, user.email),
                      class: "-mt-1 text-sm text-muted"
                    }, null, 8, _hoisted_18))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 42, _hoisted_14)), [
            [_directive_wave]
          ])
        }), 128))
      ], 8, _hoisted_9)
    ])
  ]))
}